export interface IStudentDetailsFormModel {    
    companyId?: string
}

const studentDetailsInitValues: IStudentDetailsFormModel = {
    companyId: ''
}

export { studentDetailsInitValues }